import React from 'react';
import FilterBar from '../../components/filters/FilterBar';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import UserBehavior from '../../components/users/UserBehavior';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Behavior.css';

/**
 * User Behavior Page Component
 * Analyze feature adoption, usage patterns, and preferences
 */
const BehaviorPage = () => {
  const { period, setPeriod } = useFilterPersistence({
    pageKey: 'user-behavior',
    defaultPeriod: FILTER_PERIODS.ALL
  });

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.USER_BEHAVIOR.title}
        description={PAGE_INFO.USER_BEHAVIOR.description}
        filters={filters}
      >
        <div className="behavior-content">
          <UserBehavior period={period} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default BehaviorPage;

